import { patternNombre, patternApellidoPaterno, patternApellidoMaterno, patternTelefono, patternCelular, patternEmail, patternEmail2, patternTratamiento } from '../Validations/patterns';

/**
 * 
 * @param {String} text Nombre del lead
 * @returns {Boolean}
 */
export const validarTratamiento = (text) => {
    if (text === undefined) return false;
    if (text === "") return false;

    return patternTratamiento.test(text)
};
export const validarNombre = (text) => {
    if (text === undefined) return false;
    if (text === "") return false;

    return text.length <= 40 && patternNombre.test(text)
};
export const validarApellidoPaterno = (text) => {
    if (text === undefined) return false;
    if (text === "") return false;

    return text.length <= 80 && patternApellidoPaterno.test(text)
};
export const validarApellidoMaterno = (text) => {
    if (text === undefined) return false;
    if (text === "") return false;

    return text.length <= 150 && patternApellidoMaterno.test(text)
};
export const validarTelefono = (text) => {
    if (text === undefined) return false;
    if (text === "") return false;

    return patternTelefono.test(text);
};
export const validarCelular = (text) => {
    if (text === undefined) return false;
    if (text === "") return false;

    return patternCelular.test(text);
};
export const validarCorreo = (text) => {
    if (text === undefined) return false;
    if (text === "") return false;

    return text.length <= 80 && patternEmail.test(text) && patternEmail2.test(text)
};
export const validarCorreo2 = (text) => {
    var expresionRegular = /^[a-zA-Z0-9@._-]*$/;

    return expresionRegular.test(text)
};
export const validarVin = (text) => {
    if (text === undefined) return false;
    if (text === "") return false;

    var expresionRegular = /^[A-Z0-9]{17}$/;

    return expresionRegular.test(text)
};

export const validarCodigoPostal = (text) => {
    if (text === undefined) return false;
    if (text === "") return false;
    var expresionRegular = /^[0-9]{5}$/;

    return expresionRegular.test(text)
};

export const addUtmsToLead = (lead, utms) => {
    let utmsString = '';
    if (utms?.utm_source) {
        utmsString = utmsString + '||' + utms.utm_source;
    }
    if (utms?.utm_id) {
        utmsString = utmsString + '||' + utms.utm_id;
    }
    if (utms?.utm_medium) {
        utmsString = utmsString + '||' + utms.utm_medium;
    }
    if (utms?.utm_campaign) {
        utmsString = utmsString + '||' + utms.utm_campaign;
    }
    if (utms?.utm_term) {
        utmsString = utmsString + '||' + utms.utm_term;
    }
    if (utms?.utm_content) {
        utmsString = utmsString + '||' + utms.utm_content;
    }

    return { ...lead, vehiculoActual: utmsString }
}